export const convertZeroToOne = (value: any) => {
    return (value === 0) ? 1 : value;
}